import type {ReactNode} from 'react';

import AssistantOverlay from '../components/AiDocsAssistant/AssistantOverlay';
import {AssistantProvider} from '../components/AiDocsAssistant/AssistantContext';
import PageContextTracker from '../components/AiDocsAssistant/PageContextTracker';

export default function Root({children}: {children: ReactNode}): ReactNode {
  return (
    <AssistantProvider>
      <PageContextTracker />
      {children}
      <AssistantOverlay />
    </AssistantProvider>
  );
}
